<template>
  <div class="card">
    <div class="card-body">
      <h5 class="card-title">Name: {{ advanced_visual.name }}</h5>
      <div
        :style="
          'background-color: ' +
          advanced_visual.background_color +
          ';height:600px;font-size:3vw;'
        "
      >
        <div
          class="row h-100"
          v-if="advanced_visual.template_id === 1"
          :style="'background-color:' + advanced_visual.background_color"
        >
          <div class="col-12">
            <div class="row h-25 text-left">
              <div class="col-6 visual-section">
                <editor
                  inline
                  v-model="advanced_visual.resolutions[0].content2"
                  :api-key="tinyMCEGlobalConfig.api_key"
                  :disabled="true"
                  class="custom-editor"
                >
                </editor>
              </div>
              <div class="col-6 text-right visual-section">
                <editor
                  inline
                  v-model="advanced_visual.resolutions[0].content3"
                  :api-key="tinyMCEGlobalConfig.api_key"
                  :disabled="true"
                  class="custom-editor"
                >
                </editor>
              </div>
            </div>
            <div class="row h-50">
              <div
                :class="{
                  'col-1': true,
                  'visual-section': true,
                }"
              ></div>
              <div class="col-10 text-center visual-section">
                <editor
                  inline
                  v-model="advanced_visual.resolutions[0].content1"
                  :api-key="tinyMCEGlobalConfig.api_key"
                  :disabled="true"
                  class="custom-editor"
                >
                </editor>
              </div>
              <div
                :class="{
                  'col-1': true,
                  'visual-section': true,
                }"
              ></div>
            </div>
            <div class="row h-25">
              <div class="col-6 text-left visual-section">
                <editor
                  inline
                  v-model="advanced_visual.resolutions[0].content4"
                  :api-key="tinyMCEGlobalConfig.api_key"
                  :disabled="true"
                  class="custom-editor"
                >
                </editor>
              </div>
              <div class="col-6 text-right visual-section">
                <editor
                  inline
                  v-model="advanced_visual.resolutions[0].content5"
                  :api-key="tinyMCEGlobalConfig.api_key"
                  :disabled="true"
                  class="custom-editor"
                >
                </editor>
              </div>
            </div>
          </div>
        </div>
        <div
          class="row h-100"
          v-if="advanced_visual.template_id === 2"
          :style="'background-color:' + advanced_visual.background_color"
        >
          <div class="col-12">
            <div class="row h-100">
              <div class="col-12 text-center visual-section">
                <editor
                  inline
                  v-model="advanced_visual.resolutions[0].content1"
                  :api-key="tinyMCEGlobalConfig.api_key"
                  :disabled="true"
                  class="custom-editor"
                >
                </editor>
              </div>
            </div>
          </div>
        </div>
        <div
          class="row h-100"
          v-if="advanced_visual.template_id === 4"
          :style="'background-color:' + advanced_visual.background_color"
        >
          <div class="col-12">
            <div class="row h-25 text-left">
              <div class="col-12 visual-section">
                <editor
                  inline
                  v-model="advanced_visual.resolutions[0].content3"
                  :api-key="tinyMCEGlobalConfig.api_key"
                  :disabled="true"
                  class="custom-editor"
                >
                </editor>
              </div>
            </div>
            <div class="row h-75">
              <div class="col-6 text-center visual-section">
                <editor
                  inline
                  v-model="advanced_visual.resolutions[0].content1"
                  :api-key="tinyMCEGlobalConfig.api_key"
                  :disabled="true"
                  class="custom-editor"
                >
                </editor>
              </div>
              <div class="col-6 text-center visual-section">
                <editor
                  inline
                  v-model="advanced_visual.resolutions[0].content2"
                  :api-key="tinyMCEGlobalConfig.api_key"
                  :disabled="true"
                  class="custom-editor"
                >
                </editor>
              </div>
            </div>
          </div>
        </div>
        <div
          class="row h-100"
          v-if="advanced_visual.template_id === 3"
          :style="'background-color:' + advanced_visual.background_color"
        >
          <div class="col-12">
            <div class="row h-100">
              <div class="col-6 text-center visual-section">
                <editor
                  inline
                  v-model="advanced_visual.resolutions[0].content1"
                  :api-key="tinyMCEGlobalConfig.api_key"
                  :disabled="true"
                  class="custom-editor"
                >
                </editor>
              </div>
              <div class="col-6 text-center visual-section">
                <editor
                  inline
                  v-model="advanced_visual.resolutions[0].content2"
                  :api-key="tinyMCEGlobalConfig.api_key"
                  :disabled="true"
                  class="custom-editor"
                >
                </editor>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Editor from '@tinymce/tinymce-vue'

export default {
  name: 'AdvancedVisualPreview',
  props: {
    advanced_visual: {
      type: Object,
      required: true
    }
  },
  components: {
    editor: Editor
  },
  data: function () {
    return {
      tinyMCEGlobalConfig: {
        api_key: '5i8aeub8k5so19rj2bdfd2qgu5vjsp2gx063fxi3tzs4jw27'
      }
    }
  },
  created () {},
  computed: {}
}
</script>

<style scoped>
.custom-editor {
  height: 100%;
}
</style>
